import { OnboardingPage, useOnboarding } from '@bb/onboarding-core';
import { useAuth } from '@bb/session-manager';
import { PLAYBOOK_BUILDER_PERMISSION, UPLOAD_CONTRACT_PERMISSION } from '../../groups.config';
import { isWebFtueEnabled } from './webFtueFlag';

/**
 * Renders the shared FTUE full-screen when the user is a first-time user (0 real
 * playbooks — determined by OnboardingProvider). Gated by:
 *  - the dark-launch flag (off by default until verified), and
 *  - the permissions the flow needs (create a playbook + upload contracts); users who
 *    lack them are never dead-ended into an FTUE they can't complete.
 *
 * Returns null (renders nothing) when the FTUE should not show, so the normal app renders.
 */
export function WebFtue() {
  const { isFirstTimeUser, isCheckingOnboarding } = useOnboarding();
  const { hasAllPermissions } = useAuth();

  if (!isWebFtueEnabled()) {
    return null;
  }
  if (isCheckingOnboarding || !isFirstTimeUser) {
    return null;
  }
  if (!hasAllPermissions([PLAYBOOK_BUILDER_PERMISSION, UPLOAD_CONTRACT_PERMISSION])) {
    return null;
  }

  return <OnboardingPage />;
}
